import axios from 'axios'
import { API_BASE_URL } from '../globalVar'

let baseUrl = API_BASE_URL

export const resellerApiService = {
    getResellers,
    getEmailBrandingForReseller
}

function getResellers() {
    return axios.get(baseUrl + '/api/admin/v1/reseller/getAll')
}

function getEmailBrandingForReseller(payload) {
    return axios.get(baseUrl + '/api/admin/v1/reseller/brandingForReseller/' + payload)
}
